import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import permission from './permission'
import * as types from './types'

Vue.use(Vuex)
const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production', // 使用严格模式
    modules: {
        user,
        permission
    },
    state: {
        showDropdown: false,
        K12TYPE: types.K12TYPE, // k12学校类型
        UNK12TYPE: types.UNK12TYPE // 非K12学校类型
    },
    mutations: {
        toggleDropdown (state) {
            state.showDropdown = !state.showDropdown;
        },
        hideDropdown (state) {
            state.showDropdown = false;
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/stores/index.js